import { useMutation, useQueryClient } from '@tanstack/react-query';
import { mapAPIUrl, paramsToUrl, qkeyFromUrl } from '@/utils';
import { sessionState as session } from '../../app/sessionState';
import { default as appConfig } from '@/app/config';
import { useLoading } from '@/app/LoadingProvider';

const deepMerge = (target, source) => {
  const output = { ...target };

  if (isObject(target) && isObject(source)) {
    Object.keys(source).forEach(key => {
      if (isObject(source[key])) {
        if (!(key in target)) {
          output[key] = source[key];
        } else {
          output[key] = deepMerge(target[key], source[key]);
        }
      } else {
        output[key] = source[key];
      }
    });
  }

  return output;
};

const isObject = (item) => {
  return (item && typeof item === 'object' && !Array.isArray(item));
};

export const useAPIMutation = ({
  APIRequest,
  method = 'PUT',
  previousData = null,
  headers = {},
  config = {},
}) => {
  const queryClient = useQueryClient();
  const { startLoading, stopLoading } = useLoading();

  const { showLoading = false } = config;

  let url = '';
  let parameters = undefined;

  if (typeof APIRequest === 'string') {
    url = APIRequest;
  } else if (APIRequest?.url) {
    url = APIRequest.url;
    parameters = APIRequest.parameters;
  } else if (APIRequest?.sampleData) {
    url = APIRequest.sampleData;
  }

  var qkey = qkeyFromUrl(url);

  if (parameters) {
    url = paramsToUrl(url, parameters);
  }

  return useMutation({
    mutationFn: async (formData) => {
    
      let loaderId = null;
      let success = false;
      try {
        if (showLoading) {
          loaderId = startLoading();
        }

        let body = previousData ? deepMerge(previousData, formData) : formData;       

        let options = {
          method: method || 'POST',
          credentials: 'include',
          headers: {
            'Content-Type': 'application/json',
            ...headers,
          },
          body: JSON.stringify(body),
        };
        

        let finalUrl = url;

        if (!finalUrl.includes('://')) {
          finalUrl = appConfig.API_URL + finalUrl;
          options.headers.Authorization = `Bearer ${session.token}`;
        }

        if (finalUrl.indexOf('https://api.adenin.com') > -1) {
          finalUrl = finalUrl.replace('https://api.adenin.com', appConfig.API_URL);
          options.headers.Authorization = `Bearer ${session.token}`;
        }

        //console.log('Request:', finalUrl, options);
        const res = await fetch(finalUrl, options);
        if (!res.ok) {
          throw new Error('API call failed');
        }

        let data = await res.json();
        if(data.ErrorCode === 0) {
          data = data.Data;
        }

        const result = { data };

        success = true;

        if (showLoading === "show" && loaderId) {
          result._loaderId = loaderId;
        }

        return result;
      } finally {
        if ((!success || showLoading !== "show") && showLoading && loaderId) {
          stopLoading(loaderId);
        }
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries([qkey]);
    },
  });
};
